export enum AnalyticalEngineWorkspaceCapabilityAccessOperation {
    create = "c5bac657-1759-491a-a635-202983907913",
    read = "485e0757-6b44-4236-afb9-26fc47bbd0d6",
    update = "fbf75e5c-dda9-4c04-b3b8-87bab51f2b55",
    delete = "b5ca77df-00be-4ea2-9aa9-26851620e743",
}
